import React from 'react';
import { useReportSelect } from './useReportSelect';
import { PopupSelect } from '../../../CommonComponents/OPL/Select/PopupSelect/PopupSelect';
import { Wrapper } from '../../../CommonComponents/OPL/Wrapper/Wrapper';
import { MarginProps } from '../../../theme/styledProps';
import { ReportOption } from '../../types';
import { useSelectedReport } from '../../state';
import { Text } from '../../../CommonComponents/OPL/Text/Text';

export const ReportSelect: React.FC<MarginProps> = props => {
  const { data, actions } = useReportSelect();

  const { selectedReport } = useSelectedReport();

  if (!data) {
    return null;
  }

  const { reportOptions } = data;

  const { onSelectReport } = actions;

  return (
    <Wrapper {...props}>
      <Text as="span" id="adv-select-report" variant="formLabel" color="neutral.600" mb="4">
        Report
      </Text>

      <PopupSelect
        placeholder="Select Report"
        aria-labelledby="adv-select-report"
        value={selectedReport}
        options={reportOptions}
        onChange={report => {
          onSelectReport(report as ReportOption);
        }}
      />
    </Wrapper>
  );
};
